import classNames from 'classnames';
import dayjs from 'dayjs';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';
import { planStatus } from '@/shared/constants/plan';

import { Pagination } from '@/types/pagination';

export const PlanColumns = (
  t: any,
  onEditPlan?: (id: number) => void,
  onEditStatusPlan?: (isActive: boolean, rowData: any) => void,
  pagination?: Pagination,
): ColumnDescription[] => [
  {
    dataField: 'index',
    text: t('plan_list.id'),
    headerClassname: 'text-center min-w-[80px]',
    classname: 'min-w-[80px] text-gray-700 text-center',
    formatter: (rowData, index) => {
      const pageOffset = ((pagination?.paginate ?? 1) - 1) * 10;
      return index.rowIndex + pageOffset + 1; 
    },
  },
  {
    dataField: 'name',
    text: t('plan_list.name'),
    headerClassname: 'min-w-[233px]',
    classname: 'min-w-[233px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip target={`.tooltip-point-${rowData.id}-name`}>
            {rowData.name}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-2 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-name`,
            )}
            data-pr-position="top"
          >
            {rowData.name}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'price',
    text: t('plan_list.price'),
    headerClassname: 'w-[233px]',
    classname: 'w-[233px] text-gray-700',
    formatter: (rowData) => (
      <div>{`${rowData.price.toLocaleString("ja-JP")}${t('plan.price_prefix')}`}</div>
    ),
  },
  {
    dataField: 'student_limit',
    text: t('plan_list.max_student'),
    headerClassname: 'w-[233px]',
    classname: 'w-[233px] text-gray-700',
    formatter: (rowData) => (
      <div>{rowData.student_limit || '-'}</div>
    ),
  },
  {
    dataField: 'created_at',
    text: t('plan_list.created_date'),
    headerClassname: 'w-[233px]',
    classname: 'w-[233px] text-gray-700',
    sort: true,
    formatter: (rowData) => (
      <div>
        {rowData.created_at
          ? dayjs(rowData.created_at.toString()).format('YYYY/MM/DD')
          : '-'}
      </div>
    ),
  },
  {
    dataField: 'action',
    text: '',
    sort: false,
    classname: 'min-w-[132px] text-center [&>div]:justify-center',
    headerClassname: 'min-w-[132px] [&>div]:justify-center',
    formatter: (rowData) => (
      <div className="flex flex-row h-[36px] items-center gap-8">
        <InputSwitch
          checked={rowData.status === planStatus.PUBLIC ? true : false}
          onChange={(e) => onEditStatusPlan?.(e.value, rowData)}
        />
        <Button className="p-[5px]" onClick={() => onEditPlan?.(rowData.id)}>
          <span className="pi pi-pencil" />
        </Button>
      </div>
    ),
  },
];
